module.exports = __webpack_public_path__ + "img/black.c3d651ea.jpeg";